export default "https://cdn-static.gokick.com/assets/38a17193d7f2ad0638d84ec7199a8f76eb0c19ef/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";